import PropTypes from "prop-types";
import React, {
	Component
} from "react";
import {
	View
} from "react-native";
import ResponsiveStylesheet from "react-native-responsive-stylesheet";

import SubForm from "./Subform";
import Picker from "./Picker";

import Style from "ae-style";
import StyledButton from "ae-base/Base/StyledButton";

import memoize from "memoizee";

const styles = ResponsiveStylesheet.createSized("min-direction", {
	0: {
		actions: {
			marginVertical: Style.layout.marginSmall
		}
	},
	512: {
		actions: {
			marginVertical: Style.layout.marginContentSmall
		}
	}
});

export default class SubFormWithChangeAllTo extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: props.defaultValue || {},
			count: 0
		};

		const properties = props.schema.properties || {};
		if (!(props.defaultValue && Object.keys(props.defaultValue).length > 0)) {
			const defaultValue = Object.keys(properties).reduce((acc, property) => {
				acc[property] = undefined;
				return acc;
			}, {});
			this.state.data = defaultValue || {};
		}

		this.handleChangeAllTo = memoize(makeChanger.bind(this));
	}

	render() {
		const props = this.props;
		const state = this.state;
		const {changeAllTo, changeAllToDetails, ...restSchema} = props.schema || {};
		const {defaultValue, schema, ...restProps} = props;
		const newDefaultValue = state.data;
		const enums = changeAllToDetails && changeAllToDetails.enum;
		changeAllToDetails.type = "number";
		changeAllToSchema = {
			type: "object",
			properties: {
				changeAllToDetails
			}
		}

		const renderChangeAllToDropDown = (changeAllTo && enums && enums.length > 0) ? (
			<SubForm
				key={"change_all_to_drop_down"}
				id={props.id + "_change_all_to_drop_down"}
				schema={changeAllToSchema}
				onChange={this.handleChangeAllTo}
			/>) : null;


		return (
			<View>
				{renderChangeAllToDropDown}
				<SubForm
					key={"form_sections_" + this.state.count}
					id_prefix={props.id + "_"}
					schema={restSchema}
					defaultValue={newDefaultValue}
					{...restProps}
				/>
			</View>
		);
	}
}

function makeChanger(property) {
	const value = property.changeAllToDetails;
	const data = this.state.data || {};
	const onChange = this.props.onChange;
	const count = this.state.count;

	const newData = Object.keys(data).reduce((newDataObj, key) => {
		newDataObj[key] = value;
		return newDataObj;
	}, {});

	if (onChange) {
		onChange(newData);
	}
	
	this.setState({
		data: newData,
		count: count + 1
	});
}

import types from "./Layout/inputTypes";

SubFormWithChangeAllTo.propTypes = types;

SubFormWithChangeAllTo.contextTypes = {
	localizeFrom: PropTypes.func,
	localize: PropTypes.func
};
